import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from '../../domains/auth';
import { GlobalConfigService } from '../services';

export function baseUrlInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const authService = inject(AuthService);
    const globalConfigService = inject(GlobalConfigService);
    const router = inject(Router);

    /* Only update the URL is it's not an absolute URL */
    const isAbsoluteUrl = req.url.startsWith('http://') || req.url.startsWith('https://');

    const apiReq = isAbsoluteUrl
        ? req
        : req.clone({
              url: `${globalConfigService.apiUrl}/${req.url}`,
              withCredentials: true
          });

    /* Return next(req) to continue. Add the pipe to get access to the response */
    return next(apiReq).pipe(
        catchError((error) => {
            const isAuthPage = router.url.includes('auth');

            /* Redirect the user to the Sign In Page if: 
                - They're accessing our API
                - They're not on an Auth Page (incorrect sign in attempts return 401)
                - The user is Unauthorized - 401 Status Returned */
            if (!isAbsoluteUrl && error.status === 401 && !isAuthPage) {
                const currentUrl = router.url;

                authService.clearClientAuthState();

                /* Make sure all Auth Cookies are cleared, then navigate to Sign In page */
                authService.postClearAuthTokens().subscribe(() => {
                    authService.navigateToSignIn(currentUrl);
                });
            }

            return throwError(() => error);
        })
    );
}
